import { TypeSignUpApplicationResponse } from '../Hooks'

export const isVerificationSuccessful = (
  verification: TypeSignUpApplicationResponse | undefined
) => {
  if (!verification) {
    return false
  }

  return (
    !verification.duplicateExists &&
    !verification.potentialSanctionedMatch &&
    !verification.potentialFraudMatch &&
    verification.isVerified
  )
}
